import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type CategoryLocalizations = {
	"en-us": string;
	"de-ch": string;
	"de-de": string;
	"fr-fr": string;
	"it-it": string;
};

type CreateCategoryPayload = {
	localizations: CategoryLocalizations;
	customSequence: number;
	defaultSequence: number;
	legacyValue: null;
	parentCategoryFk: string | null;
};

const createCategory = async (payload: CreateCategoryPayload): Promise<any> => {
	const response = await apiDal.post("/categories/create", payload);
	return response.data;
};

export const useCreateCategory = () => {
	return useMutation({
		mutationFn: createCategory,
	});
};
